export enum AdvertisementLayoutType {
  HORIZONTAL = "HORIZONTAL",
  VERTICAL = "VERTICAL",
}

export enum AdvertisementLayoutPosition {
  IMAGE_LEFT = "IMAGE_LEFT",
  IMAGE_RIGHT = "IMAGE_RIGHT",
  IMAGE_TOP = "IMAGE_TOP",
  IMAGE_BOTTOM = "IMAGE_BOTTOM",
}

export interface IAdvertisementImage {
  id: number;
  imageKey: string;
  duration: number;
  order: number;
}

export interface IAdvertisementText {
  id: number;
  content: string;
  duration: number;
  order: number;
}

export interface IAdvertisement {
  id: number;
  name: string;
  layoutType: AdvertisementLayoutType;
  layoutPosition: AdvertisementLayoutPosition;
  isActive: boolean;
  order: number;
  images: IAdvertisementImage[];
  texts: IAdvertisementText[];
}
